import { Signal } from '../..';

import type { Entity } from '../Entity';

export class Group<TYPE = Entity> {
  public children: TYPE[];
  public readonly onAdded: Signal<(ent: TYPE) => void> = new Signal();
  public readonly onRemoved: Signal<(ent: TYPE) => void> = new Signal();

  constructor(children: TYPE[] = []) {
    this.children = children;
  }

  public add(item: TYPE): void {
    const index = this.children.indexOf(item);

    if (index !== -1) return;

    this.children.push(item);
    this.onAdded.emit(item);
  }

  public remove(item: TYPE): boolean {
    const index = this.children.indexOf(item);

    if (index === -1) return false;

    this.children.splice(index, 1);
    this.onRemoved.emit(item);

    return true;
  }

  public contains(item: TYPE): boolean {
    return this.children.indexOf(item) !== -1;
  }

  public getIndex(item: TYPE): number {
    return this.children.indexOf(item);
  }

  public getItem(index: number): TYPE {
    return this.children[index];
  }

  public run(f: (item: TYPE) => void, scope?: any): void {
    let i: number;

    if (scope) {
      for (i = 0; i < this.children.length; i++) {
        f.call(scope, this.children[i]);
      }
    } else {
      for (i = 0; i < this.children.length; i++) {
        f(this.children[i]);
      }
    }
  }

  public empty(): void {
    this.children.length = 0;
    this.onAdded.disconnectAll();
    this.onRemoved.disconnectAll();
  }

  public get length(): number {
    return this.children.length;
  }
}
